'use client';
/* eslint-disable jsx-control-statements/jsx-jcs-no-undef */
import { web3Navigate } from '@web3/base-utils';
import React, { Ref } from 'react';

export type Web3LinkProps = {} & React.DetailedHTMLProps<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
>;

export const Web3Link = React.forwardRef((props: Web3LinkProps, ref) => {
  return (
    <a
      {...props}
      ref={ref as Ref<HTMLAnchorElement>}
      onClick={(e) => {
        if (props.onClick) {
          props.onClick(e);
        }
        if (!props.href) {
          return;
        }
        e.preventDefault();
        web3Navigate(props.href);
      }}
    />
  );
});
